
export const partners = [
  {
    image: "./chinaH20.png",
    name: "China Water",
  },
  {
    image: "./cyberport.png",
    name: "Cyberport",
  },
  {
    image: "./scc.png",
    name: "SCC",
  },
  {
    image: "./cm32.jpg",
    name: "CM32",
  },  
  {
    image: "./thinxtra.jpg",
    name: "ThinXtra",
    company: "ThinXtra",
  },
];

export const skills = [
  "Layered System Design",
  "Provisioning / Deployment Process",
  "Data Analytics",
  "System-on-a-Chip (SoC) designs",
  "Sub-1 GHz Communications",
  "Open Standards from IEEE, IETF, OMA",
];



// WEBPACK FOOTER //
// ./src/data.js